<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <div class="flex flex-row justify-between">
            <h1 class="font-bold text-xl">Upload Image(s)</h1>
            <button type="button" (click)="onCancel()" class="text-gray-300 hover:text-gray-300 focus:outline-none">
                <i class="fas fa-xmark text-xl"></i></button>
        </div>
        <div class="w-full my-4">
            <s3-images-upload #imageUploader label="Upload Image(s)" [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                subTitle="Upload upto 10 images at a time" [filePath]="filePath" [apikey]="apiKey"
                [metadata]="metadata"></s3-images-upload>
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <app-btn-action label="Upload" (clicked)="onAddImages()" bgColor="bg-primary-500"
                textColor="text-white"></app-btn-action>
        </div>
    </div>
</div>